export enum DurationUnits {
    YEARS = 'years',
    MONTHS = 'months',
    WEEKS = 'weeks',
    DAYS = 'days',
    HOURS = 'hours',
    MINUTES = 'minutes',
    SECONDS = 'seconds',
}
